module.exports = __webpack_public_path__ + "img/202009-group.c7f1a1d4.jpg";